module.exports = __webpack_public_path__ + "img/chibuike.f6c48d40.jpg";